import axios from 'axios'
import { sanitizeSavingsPlan } from './utilsSavingPlanBFF'
import { SAVINGS_PLAN_ENDPOINT } from 'cfgCommon/endpoints'

export async function createSavingsPlan(savingsPlan, car_lot_id, checkFeeIncluded) {
    try {
        const savingsPlanBody = sanitizeSavingsPlan(savingsPlan, car_lot_id, checkFeeIncluded)

        const response = await axios.post(`${SAVINGS_PLAN_ENDPOINT}/`, savingsPlanBody)

        return response
    } catch (error) {
        // Si vuelve un error con mensaje mensaje del backend, se usa ese mensaje
        if (error?.response?.data?.message) error.message = error.response.data.message

        throw error
    }
}
